import { List } from 'immutable';

function sortObjectMap(obj, fn) {
    Object.keys(obj).forEach(key => {
        obj[key].sort((a, b) => {
            let lhs = fn(a);
            let rhs = fn(b);

            if (lhs < rhs) return -1;
            if (lhs > rhs) return 1;
            return 0;
        });
    });

    return obj;
}

/**
 * Given an array of projects, this function returns a map of projects grouped
 * by their parent division
 */
function projectsByDivision(projects) {
    const divisions = {};

    projects.forEach(p => {
        let projectsByDivision = divisions[p.divisionID]
        if (!projectsByDivision) {
            projectsByDivision = [];
            divisions[p.divisionID] = projectsByDivision;
        }

        if (p.action !== 'D') {
            projectsByDivision.push(p);
        }
    });

    return sortObjectMap(divisions, p => p.name.toLowerCase());
}

/**
 * Given an array of project sites, this function returns a map of sites where each key is the
 * parent project associated to the site
 */
function sitesByProject(projectSites) {
    const projects = {};

    projectSites.forEach(ps => {
        let siteData = projects[ps.projectID];
        if (!siteData) {
            siteData = [];
            projects[ps.projectID] = siteData;
        }
        siteData.push(ps);
    });

    return sortObjectMap(projects, s => s.name.toLowerCase());
}

/**
 * Given an array of siteZones, this function returns a map of sites, whose values are an array
 * of zones associated to each site. Uses siteID as the key since siteCode is no longer unique.
 */
function zonesBySite(siteZones) {
    const sites = {};

    siteZones.forEach(sz => {
        let zones = sites[sz.siteID];
        if (!zones) {
            zones = [];
            sites[sz.siteID] = zones;
        }

        zones.push(sz);
    });

    return sortObjectMap(sites, z => z.name.toLowerCase());
}

/**
 * This top level function is used for mapping the data returned from the server into
 * more easily consumed data used by the client
 */
export function mapData(config) {

    return {
        projects: projectsByDivision(config.projects),
        sites: sitesByProject(config.projectSites),
        zones: zonesBySite(config.siteZones),

        // awardableComps: config.awardableComps,
        // companyNames: config.companyNames,
        // competenceNames: config.competenceNames,
        // divisionCompetences: config.divisionCompetences,
        // projectCompetences: config.projectCompetences,
        // projectNames: config.projectNames,
        // projectSupervisorsEnabled: config.projectSupervisorsEnabled,
        // scheduledComps: config.scheduledComps,
        // siteCompetences: config.siteCompetences,
        // supervisorDataLastDownloaded: config.supervisorDataLastDownloaded,
        // supervisorID: config.supervisorID,
        // zoneCompetences: config.zoneCompetences
    };
}

/**
 * Given an array of projects, this function extracts the unique set of divisions
 * referenced by each project
 */
export function divisions(divisionArray, divisionIdsToFilter = []) {
    return List(divisionArray || [])
        .filter(d => divisionIdsToFilter.indexOf(d.divisionID) < 0)
        .sortBy(d => d.divisionName.toLowerCase())
        .toArray();
}